import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {FILE_TYPE, isImage} from '../../../Helpers/fileType';
import FaceDetectorApp from './FaceDetectorApp';
import {PHOTO_PICKER_MODEL} from '../SubComponent/Models/Models';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param useRef fileInputRef: Reference to the file container
 * @param useState setPhotoPickerFile: state to update the component model
 * @param model accept: Model of document types accepted by the component - default for image (required).
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param boolean isMultipleFile: Indicates whether multiple files will be uploaded.
 *
 */
const FileUploadApp = ({ fileInputRef, setPhotoPickerFile, accept, validateFace, isMultipleFile}) => {


    const { t } = useTranslation();

    const { handleValidateFace } = FaceDetectorApp();
    /**
     * Event handler: drag and drop files
     * @param e
     */
    const handleDragOver = (e) => {
        e.preventDefault();
        e.target.classList.add('dragover');
    };

    /**
     * Drag event for files
     * @param e
     */
    const handleDrop = (e) => {
        e.preventDefault();
        e.target.classList.remove('dragover');
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            fileInputRef.current.files = files;
            onFileChange({ target: fileInputRef.current });
        }
    };


    /**
     * handler to validate and select files
     */
    const onFileChange = async  (e) => {
        const selectedFiles = e.target.files;
        const regex = accept.regex

        if(!selectedFiles || selectedFiles?.length <= 0){
            return ;
        }
        for (const file of e.target.files) {
            if (!regex.test(file.name)) {
                toast.warning(t('error_file_format'));
                fileInputRef.current.value = null;
                return;
            } else if (file.size > accept.size) {
                toast.warning(`${t('the_file_size_should_not_exceed')} ${accept.size / 1024}KB.`);
                fileInputRef.current.value = null;
                return;
            } else {
                let auxFile= file;
                if(validateFace && isImage(auxFile)){
                    handleValidateFaces(auxFile);
                }else{
                    handleSetImage(auxFile);
                }
            }
        }
        fileInputRef.current.value = null;
    };

    /**
     * handler to validate faces
     * @param auxFile
     * @returns {Promise<void>}
     */
    const handleValidateFaces = async (auxFile) => {
        const faces = await handleValidateFace(auxFile);
        if(faces == 0){
            toast.warning(t("no_face_detected"))
        }else if(faces == 1){
            handleSetImage(auxFile)
        }else if(faces > 1) {
            toast.warning(t("more_than_one_face_detected"));
        }
    }

    /**
     * handler to assign file to the setPhotoPickerFile variable
     * @param auxFile
     */
    const handleSetImage = (auxFile) => {
        const isImage = FILE_TYPE.IMAGE.regex.test(auxFile.name);
        const srcSelected = isImage ? URL.createObjectURL(auxFile) : null;

        if (isMultipleFile) {
            const newItem = {
                ...PHOTO_PICKER_MODEL,
                fileSelected: auxFile,
                srcSelected
            };

            setPhotoPickerFile(prev => ({
                ...prev,
                listFiles: [...prev.listFiles, newItem]
            }));
        } else {
            setPhotoPickerFile(prev => ({
                ...prev,
                fileSelected: auxFile,
                srcSelected
            }));
        }
    };

    return {
        t,
        onFileChange,
        handleDragOver,
        handleDrop
    }

}

export default FileUploadApp;
